import {Grid, Tooltip} from "@mui/material";
import {labelStyle, valueStyle} from "../../../styles";
import {FormattedMessage, MessageDescriptor} from "react-intl";
import {ReactElement} from "react";

type Props = {
    label: MessageDescriptor;
    tooltipTitle: string | ReactElement<any>;
    all: number;
    notRegistered: number;
};

const DeviceSummary = ({label, tooltipTitle, all, notRegistered}: Props) => {
    return (
        <Grid container>
            <Grid style={labelStyle} size={2}>
                <span>
                    <FormattedMessage {...label} />:
                </span>
            </Grid>
            <Grid style={valueStyle} size={2}>
                <Tooltip title={tooltipTitle} placement="right">
                    <span>
                        {all}/{notRegistered}
                    </span>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

export default DeviceSummary;
